// extracted by mini-css-extract-plugin
export default {"test":"Tree_test__EsCTc","svgtest":"Tree_svgtest__BeFkg"};